import styled from 'styled-components';

export const EvidenceText = styled.p`
  margin: 0;
  white-space: pre-wrap;
`;
